import React, { useContext } from 'react';
import { GlobalContext } from '../../contexts/HomeContext';
import StoneLogo from './StoneLogo';
import Default from './Default';

interface Props {
  isPix: boolean;
}

const GatewaysLogo: React.FC<Props> = ({ isPix = false }) => {
  const { dadosApp } = useContext(GlobalContext);

  const CartaoOperadora = dadosApp.Empresa.Config.cartao_operadora;
  const PixOperadora = dadosApp.Empresa.Config.pix_operadora;
  const OPERADORA = isPix ? PixOperadora : CartaoOperadora;

  switch (OPERADORA?.toUpperCase()) {
    case 'STONE':
      return (
        <Default>
          <div style={{ padding: '0 30px' }}>
            <StoneLogo />
          </div>
        </Default>
      );

    default:
      return <Default>{''}</Default>;
  }
};
export default GatewaysLogo;
